import * as styles from "./JobEditor.css";

import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { Trans } from "@lingui/react/macro";

import { JobEditorBody } from "./components/JobEditorBody";
import { type UseJobEditorOptions, useJobEditor } from "./hooks/useJobEditor";

export type JobEditorProps = UseJobEditorOptions;

export function JobEditor({
  projectId,
  jobId = null,
  onSaved,
  onCancel,
}: JobEditorProps): JSX.Element {
  const { loading, saving, error, conflict, save, cancel } = useJobEditor({
    projectId,
    jobId,
    onSaved,
    onCancel,
  });

  return (
    <div className={styles.editor}>
      <JobEditorBody loading={loading} error={error} conflict={conflict} />

      <footer className={styles.footer}>
        <Button variant="ghost" onClick={cancel}>
          <Trans>Cancel</Trans>
        </Button>

        <Button
          variant="primary"
          loading={saving}
          disabled={loading}
          onClick={() => void save()}
        >
          <Trans>Save</Trans>
        </Button>
      </footer>
    </div>
  );
}
